import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import AppLayout from "../components/AppLayout";
import StationCard from "../components/StationCard";
import api from "../services/api";

export default function Favorites() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get("/api/favorites");
      setItems(res.data);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const remove = async (station) => {
    try {
      await api.delete(`/api/favorites/${encodeURIComponent(station.station_uuid)}`);
      setItems((prev) => prev.filter((s) => s.station_uuid !== station.station_uuid));
    } catch { /* ignore */ }
  };

  return (
    <AppLayout title={t("favorites.title")}>
      {loading ? (
        <p className="text-gray-500">{t("common.loading")}</p>
      ) : items.length === 0 ? (
        <p className="text-gray-500">{t("favorites.empty")}</p>
      ) : (
        <div className="grid gap-3">
          {items.map((s) => (
            <StationCard key={s.station_uuid} station={s} allowFavorite={false} onRemove={remove} />
          ))}
        </div>
      )}
    </AppLayout>
  );
}
